import cx from "classnames";
import { PropsWithChildren } from "react";

import "./StyledButtonContainer.css";

type PipDirection = "up" | "down" | "left" | "right";

export type StyledButtonContainerProps = PropsWithChildren<{
  showIndicator?: boolean;
  indicatorLit?: boolean;
  showPip?: boolean;
  // up is default
  pipDirection?: PipDirection;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}>;

/**
 * StyledButtonContainer appears as a squarish octagon with an inset dark surface and
 * an icon, with an optional pip on top and an indicator light.
 */
export function StyledButtonContainer(props: StyledButtonContainerProps) {
  const {
    children,
    showIndicator,
    indicatorLit,
    showPip,
    pipDirection = "up",
    selected,
    disabled,
    className,
    onClick
  } = props;

  return (
    <div
      className={cx(
        "styled-button-container",
        { selected, disabled },
        className
      )}
      onClick={onClick}
    >
      {showPip && (
        <div className={cx("styled-button-expansion-pip", pipDirection)} />
      )}
      <div className="styled-button-content">{children}</div>
      {showIndicator && (
        <div
          className={cx(
            "styled-button-lit-indicator",
            indicatorLit ? "lit" : "unlit"
          )}
        />
      )}
    </div>
  );
}
